import axios from "axios";
import { userInfoTypes, postUserTypes } from "./interfaces";
import GetJsonData from "./dataAccess";

const apiURL = process.env.REACT_APP_API_URL;

export const submitUser = async (user: any) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }
  try {
    const response = await axios({
      url: `https://${apiURL}/Users`,
      method: "post",
      data: {
        displayName: user.displayName,
        position: user.position,
        email: user.email.trim(),
        subcontractor: user.subcontractor,
        password: user.password,
        confirmPassword: user.confirmPassword,
        adminRole: user.adminRole,
        hourlyRate: user.hourlyRate,
        employeeTypeId: user.employeeTypeId,
        mobilePhone: user.mobilePhone,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    const data: postUserTypes = response.data;
    return data;
  } catch (error: any) {
    // if (error.response && Array.isArray(error.response.data)) {
      // If the server returns an array of error messages, aggregate them
      // const errorMessages = error.response.data
        // .map((err: any) => err.description)
        // .join("\n");
      // throw new Error(errorMessages);
    // }
    // If the error is something else (e.g., network issue, not an array, etc.), rethrow it
    throw error;
  }
};

export const getUserInfo = async (email: string): Promise<userInfoTypes> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios({
    url: `https://${apiURL}/Users/${email}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const data: userInfoTypes = response.data;

  const user = {
    email: data.email,
    userName: data.userName,
    employeeId: data.employeeId,
  };

  localStorage.setItem("user", JSON.stringify(user));

  return data;
};


export interface UserRoleOption {
  roleId: number
  area: string
  permission: string
  description?: string
}



export const getUserRoles = async (): Promise<UserRoleOption[]> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios({
    url: `https://${apiURL}/Roles/`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const data: UserRoleOption[] = response.data;

  return data;
};


export const getEmployeeTypes = async () => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios({
    url: `https://${apiURL}/employeetype/fordropdown`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const data = response.data;

  return data;
};

